import {
  LOAD_EXPRESS_DATA_REQUEST,
  LOAD_EXPRESS_DATA_SUCCESS,
  LOAD_EXPRESS_DATA_FAILURE,
  RESET_EXPRESS_STATE,
} from "./constants";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

export default function expressReducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_EXPRESS_DATA_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case LOAD_EXPRESS_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case LOAD_EXPRESS_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case RESET_EXPRESS_STATE:
      return initialState;
    default:
      return state;
  }
}
